import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lp2-private-class-upsell-banner',
  templateUrl: './private-class-upsell-banner.component.html',
  styleUrls: ['./private-class-upsell-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassUpsellBannerComponent {
  @Output() contactRequest = new EventEmitter();

  public handleContactMe() {
    this.contactRequest.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-upsell-banner/private-class-upsell-banner.component.ts